<template>
  <div class="div">
    <homeMenu chooseMenu="个人中心"></homeMenu>
    <userInfo></userInfo>
  </div>
</template>

<script>

import {defineComponent} from "vue";
import homeMenu from "@/page/home/components/homeMenu.vue";
import userInfo from '@/page/home/userCenter/components/userInfo.vue'


export default defineComponent({
  components: { homeMenu,userInfo

  },
  data(){
    return{

    }
  },
})
</script>


<style scoped>

</style>